import { PortfolioActions } from '@unistocks/features/portfolios/store/portfolio.slice';
import { usePortfoliosGetListQuery } from '@unistocks/proxy/axios-client/PortfoliosQuery';
import { useAppDispatch } from '@unistocks/shared/hooks/redux-hooks';
import { t } from '@unistocks/shared/localization/index.ts';
import { Stack, useRouter } from 'expo-router';
import { useEffect } from 'react';

export const unstable_settings = {
  anchor: 'index'
};

export default function PortfoliosLayout() {
  const dispatch = useAppDispatch();
  const router = useRouter();
  const { data: portfolios, isSuccess } = usePortfoliosGetListQuery();

  // Sync portfolio state with redux
  useEffect(() => {
    if (isSuccess) {
      dispatch(PortfolioActions.syncPortfolioState(portfolios));

      if (!portfolios.items.length) router.replace('/(tabs)/portfolios/create');
    }
  }, [dispatch, isSuccess, portfolios, router]);

  return (
    <Stack
      screenOptions={{
        headerShown: false,
        contentStyle: { backgroundColor: 'transparent' }
      }}
    >
      <Stack.Screen name="index" options={{ title: t('::Menu:Portfolios') }} />
      <Stack.Screen name="[id]/index" options={{ title: t('::Portfolio') }} />
      <Stack.Screen
        name="[id]/add-asset"
        options={{ title: t('::AddWhat', { 0: t('::Holdings').toLowerCase() }) }}
      />
      <Stack.Screen name="[id]/transactions" options={{ title: t('::Transactions') }} />
      <Stack.Screen name="create" options={{ title: t('::Menu:Portfolios:Create') }} />
      <Stack.Screen name="shared/[id]/index" />
    </Stack>
  );
}
